"use client";

import React, { useRef, useState } from "react";
import { ConfigProvider, Empty, Popover, Select, Table } from "antd";
import _ from "lodash";
import { COLORS } from "../constants/Colors";
import './style/table.css'

const CustomTable = (props) => {
  const {
    column,
    data,
    total,
    scroll,
    handlePageChange,
    handleSizeChange,
    loading,
    pagination,
    page,
    rowSelection,
    onChange,
    rowKey,
    accessRole,
    onRow,
    contentAction,
    isTotalLabel,
    expandable,
    className = "",
    bordered,
    rowClassName
  } = props;
  const ref = useRef();
  const [visiblePopoverTable, setVisiblePopoverTable] = useState(false);
  const [recordPopover, setRecordPopover] = useState();
  const [offsetPopover, setOffsetPopover] = useState([0, 0]);

  const handleMouseLeave = () => {
    setVisiblePopoverTable(false);
    setRecordPopover();
    setOffsetPopover([0, 0]);
  };

  const handleMouseLeavePopover = () => {
    setVisiblePopoverTable(false);
    setRecordPopover();
    setOffsetPopover([0, 0]);
  };

  const actionTable = (record, offsetPopover, visiblePopoverTable, ref) => {
    return (
      <div onMouseLeave={handleMouseLeavePopover}>
        <Popover
          placement="right"
          trigger="click"
          open={visiblePopoverTable}
          zIndex={10000}
          content={contentAction(record)}
          align={{ offset: offsetPopover, autoArrow: false }}
          key={record?.row_id}
          showArrow={true}
        >
          <div style={{ width: 0, height: 0 }} ref={ref}></div>
        </Popover>
      </div>
    );
  };

  const paginationLocale = {
    items_per_page: "/ page",
  };

  return (
    <div onMouseLeave={handleMouseLeave}>
      <ConfigProvider
        theme={{
          components: {
            Table: {
              fontWeightStrong: "400",
            },
          },
          token: {
            fontSize: 16,
            borderRadius: 0,
          },
        }}
      >
        <Table
        className='custom-table'
          style={{border: `1px solid #E0E7F5 `,fontSize: '14px'}}
          expandable={expandable}
          // className={className}
          rowClassName={rowClassName}
          size="middle"
          rowKey={rowKey}
          locale={{ emptyText: <Empty description="ไม่พบข้อมูลในระบบ" /> }}
          loading={loading}
          columns={column}
          dataSource={data}
          bordered={bordered}
          scroll={scroll}
          rowSelection={rowSelection}
          onChange={onChange}
          pagination={
            pagination
              ? {
                  // showTotal: showTotal,
                  total: total,
                  current: page,
                  defaultCurrent: 1,
                  pageSizeOptions: ["10", "20", "30", "40", "50", "100"],
                  showSizeChanger: true,
                  onChange: handlePageChange,
                  onShowSizeChange: handleSizeChange,
                  locale: paginationLocale,
                  position: "bottomRight",
                }
              : false
          }
          onRow={
            _.isFunction(onRow)
              ? onRow
              : onRow
              ? (record, rowIndex) => {
                  return {
                    onClick: (event) => {
                      if (!event.target.href) {
                        const { x, y } = ref.current.getBoundingClientRect();
                        setVisiblePopoverTable(true);
                        setOffsetPopover([event.pageX - x, event.pageY - y]);
                        setRecordPopover(record);
                      }
                    },
                  };
                }
              : onRow
          }
        ></Table>
      </ConfigProvider>
      {isTotalLabel && _.size(data) > 0 ? (
        <span
          className=""
          style={{
            position: "relative",
            display: "flex",
            marginTop: "-40px",
            width: "200px",
          }}
        >
          ทั้งหมด {total} รายการ
        </span>
      ) : null}

      {accessRole
        ? actionTable(recordPopover, offsetPopover, visiblePopoverTable, ref)
        : null}
    </div>
  );
};

export default CustomTable;